export default function (type) {
    if ("M" === type) {
        return "Monsieur"
    } else if ("MME" === type) {
        return "Madame"
    }
    return null;
}
